import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Company } from 'src/app/models/company.model';
import { Plant } from 'src/app/models/plant.model';
import { Region } from 'src/app/models/role.model';
import { Type } from 'src/app/models/type.interface';
import { CompanysService } from 'src/app/services/companies/companies.service';
import { PlantsService } from 'src/app/services/plants/plants.service';

@Component({
  selector: 'app-edit-plant',
  templateUrl: './edit-plant.component.html',
  styleUrls: ['./edit-plant.component.scss'],
})
export class EditPlantComponent {
  public types: Array<Type> = [
    { Id: 0, TypeName: 'SWRO' },
    { Id: 1, TypeName: 'BWRO' },
  ];
  public regions: Array<Region> = [
    { Name: 'Americas' },
    { Name: 'EMEA' },
    { Name: 'APAC' },
  ];
  width: number = 0;
  plantDetails: Plant = new Plant();
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private plantsService: PlantsService,
    private companysService: CompanysService,
    private toastr: ToastrService
  ) {}

  formatsDateTest: string[] = ['yyyy/MM/dd HH:mm:ss'];
  dateNow: Date = new Date();
  companys: Company[] = [];
  PlantId: any;
  files: string[] = [];
  @ViewChild('input', { static: false }) myInputVariable: ElementRef;
  showthumbnail:boolean = true;
  showattachment:boolean = true;

  ngOnInit(): void {
    this.companysService.getAllCompanys().subscribe({
      next: (companys) => {
        this.companys = companys;
        
      },
      error: (response) => {
        console.log(response);
      },
    });

    this.route.paramMap.subscribe({
      next: (params) => {
        const id = atob(params.get('id')!);

        if (id) {
          this.plantsService.getPlant(id).subscribe({
            next: (response) => {
              this.plantDetails = response;
              console.log(this.plantDetails);
            },
          });
        }
      },
    });
  }

  

  viewFile(id: number, fileName: string) {
    this.plantDetails.Thumbnail = fileName;
    this.plantsService.getAttachment(id).subscribe(
      (data) => {
        if (data instanceof Blob) {
          const fileType = fileName.split('.').pop();
          const objectURL = URL.createObjectURL(data);
          if (
            ['jpg', 'png', 'jpeg', 'gif', 'pdf', 'xls', 'xlsx'].includes(
              fileType
            )
          ) {
            window.open(objectURL, '_blank');
          } else {
            const blob = new Blob([data], { type: data.type });
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style.display = 'none';
            const fileUrl = URL.createObjectURL(blob);
            a.href = fileUrl;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(a.href);
            a.remove();
          }
        } else {
          console.error('Error fetching attachment:', data);
        }
      },
      (error) => {
        console.error('Error fetching attachment:', error);
      }
    );
  }

  viewFile2(id: number, fileName: string) {
    this.plantDetails.Attachments = fileName;
    this.plantsService.getAttachment2(id).subscribe(
      (data) => {
        if (data instanceof Blob) {
          const fileType = fileName.split('.').pop();
          const objectURL = URL.createObjectURL(data);
          if (
            ['jpg', 'png', 'jpeg', 'gif', 'pdf', 'xls', 'xlsx'].includes(
              fileType
            )
          ) {
            window.open(objectURL, '_blank');
          } else {
            const blob = new Blob([data], { type: data.type });
            const a = document.createElement('a');
            document.body.appendChild(a);
            a.style.display = 'none';
            const fileUrl = URL.createObjectURL(blob);
            a.href = fileUrl;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(a.href);
            a.remove();
          }
        } else {
          console.error('Error fetching attachment:', data);
        }
      },
      (error) => {
        console.error('Error fetching attachment:', error);
      }
    );
  }

  addFile(files, Id) {
    if (Id == '1') {
      this.showthumbnail = false;
    }
    if (Id == '2') {
      this.showattachment = false;
    }
    if (files.length === 0) {
      return;
    }
    for (let file of files) {
      var parts = file.name.split('.');
      if (parts.length <= 1) {
        console.log('File ' + file.name + ' is not valid file');
      } else {
        this.files.push(file);
      }
    }
    this.myInputVariable.nativeElement.value = '';
  }

  updateplant() {
    const dateNowISO = this.dateNow.toISOString();
    this.plantDetails.UpdatedAt = dateNowISO;

    this.plantsService.updatePlant(this.plantDetails, this.files).subscribe({
        next: (response) => {
            this.toastr.success('Plant Updated Successfully.', 'Information');
            this.reload()
        },
        error: (response) => {
            if (response.error.length > 0) {
                this.toastr.error(response.error, 'Error');
            } else {
                this.toastr.error('Error While Updating Plant.', 'Error');
            }
        }
    });
}

reload(){
  window.location.reload();
}

  deletePlant(id: number) {
    this.PlantId = id + '';

    const confirmDelete = confirm(
      'Are you sure you want to delete this Plant?'
    );

    if (!confirmDelete) {
      return; // If the user clicks "Cancel" in the confirmation dialog, do nothing.
    }

    this.plantsService
      .deletePlant(this.PlantId)
      .subscribe((response: Response) => {
        if (response.statusText == 'Success') {
          this.toastr.error('Plant deleted successfully.', 'Information');
          this.router.navigate(['/plants']);
        } else {
          (error) => {
            console.log('Error deleting Train:', error);
          };
        }
      });
  }
}
